import { Paragraph, TextRun } from "docx";

export function buildContractSectionFromHtml(html) {
    return convertHtmlToDocx(html);
}
